<template>
    <span v-text="formatDate(issue.updatedAt, 'dd/MM/yyyy HH:mm')"></span>
</template>
<script>
import { formatDateMixin } from '@/mixins/dates';
export default {
    name: 'issue-updatedAt',
    data: () => ({}),
    mixins: [formatDateMixin],
    props: {
        issue: {},
    },
};
</script>
